import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { routePermissions } from './RoutePermissions';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = () => {
  const location = useLocation();
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  const userRole = localStorage.getItem('userType')?.toLowerCase();
  const token = localStorage.getItem('authToken');
  const currentPath = location.pathname.toLowerCase();

  useEffect(() => {
    const fetchPermissions = async () => {
      if (userRole) {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/roles/${userRole}/permissions`);
          setPermissions(res.data || {});
        } catch {
          setPermissions({});
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [userRole]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!token) return <Navigate to="/login" replace />;

  const matchedKey = Object.keys(routePermissions).find(route => {
    if (route.includes('/:')) {
      const base = route.split('/:')[0];
      return currentPath.startsWith(base);
    }
    return currentPath === route;
  });

  const permissionKey = routePermissions[matchedKey];

  if (userRole === 'admin') return <Outlet />;

  if (currentPath.startsWith('/admin') && userRole !== 'admin') {
    return <Navigate to="/access-denied" replace />;
  }

  const roleBasedRoutes = {
    recruteur: [
      "/recruteur",
      "/recruteur/talents",
      "/recruteur/candidature",
      "/recruteur/favoris",
      "/recruteur/allmissions",
      "/recruteur/top-matches",
      "/recruteur/profile",
      "/recruteur/dashboard",
      "/recruteur/sendcandidature",
      "/recruteur/mesmissions",
      "/recruteur/statistiques",
      "/recruteur/details/"
    ],
    entreprise: [
      "/entreprise",
      "/entreprise/dashboard",
      "/entreprise/candidature",
      "/entreprise/favoris",
      "/entreprise/addmission",
      "/entreprise/top-matches",
      "/entreprise/profile",
      "/entreprise/details/"
    ],
    agent: [
      "/agent",
      "/agent/cvtheque",
      "/agent/add-talent"
    ],
    commercial: [
      "/commercial",
      "/commercial/cvtheque",
      "/commercial/add-talent"
    ]
  };

  const checkRoleRoute = (allowedRoutes, role) => {
    return allowedRoutes.some(route => currentPath.startsWith(route)) && userRole !== role;
  };

  for (const role in roleBasedRoutes) {
    if (checkRoleRoute(roleBasedRoutes[role], role)) {
      return <Navigate to="/access-denied" replace />;
    }
  }

  if (permissionKey && !permissions?.[permissionKey]?.Accès) {
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
